export default __webpack_public_path__ + "static/media/content-correction.bbf6d1bb.svg";